import { AuthTokenManager } from '@classes/AuthTokenManager';
import { RefreshUnauthorizedError } from '@classes/authErrors';
import { getApiUrl } from '@utils/apiUrl';

export const BASEURL = getApiUrl();

const AUTH_PATH_RE = /^\/api\/v1\/auth(z)?\//;

let _apiOrigin = null;
function getApiOrigin() {
  if (_apiOrigin) return _apiOrigin;
  try {
    _apiOrigin = new URL(BASEURL).origin;
  } catch (e) {
    _apiOrigin = null;
  }
  return _apiOrigin;
}

export function isSameOriginAsApi(url) {
  const apiOrigin = getApiOrigin();
  if (!apiOrigin) return false;
  try {
    const target = url.startsWith('http') ? new URL(url).origin : new URL(url, apiOrigin).origin;
    return target === apiOrigin;
  } catch (e) {
    return false;
  }
}

function isAuthEndpointUrl(url) {
  try {
    const pathname = url.startsWith('http') ? new URL(url).pathname : url;
    return AUTH_PATH_RE.test(pathname);
  } catch (e) {
    return false;
  }
}

function buildRequestInit(method, body, params_headers, accessToken) {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  headers.set('Accept', 'application/json');
  params_headers?.forEach((e) => {
    headers.set(e[0], e[1]);
  });
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }
  const init = {
    method: method.toUpperCase(),
    credentials: 'include',
    headers,
  };
  if (init.method !== 'GET' && body != null) {
    init.body = body;
  }
  return init;
}

export const extendedFetch = async (url, method, body, params_headers) => {
  const sameOrigin = isSameOriginAsApi(url);
  const skipInterceptor = !sameOrigin || isAuthEndpointUrl(url);
  const initialToken = skipInterceptor ? null : AuthTokenManager.getAccessToken();
  const initialResponse = await fetch(url, buildRequestInit(method, body, params_headers, initialToken));

  if (skipInterceptor || initialResponse.status !== 401) {
    return initialResponse;
  }

  let newToken;
  try {
    newToken = await AuthTokenManager.refresh(initialToken);
  } catch (e) {
    if (e instanceof RefreshUnauthorizedError) {
      return initialResponse;
    }
    return initialResponse;
  }

  if (!newToken || newToken === initialToken) {
    return initialResponse;
  }

  return fetch(url, buildRequestInit(method, body, params_headers, newToken));
};
